/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ToggleLeft = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6" }],
    ["circle", { cx: "8", cy: "12", r: "2" }]
  ]
];

export { ToggleLeft as default };
//# sourceMappingURL=toggle-left.js.map
